export const MENTION_MARKUP = /@\[([^\]]+?)\](\(([^\)]+?)\))?/;
